import { Cell, Grid, HeadingSection, HFlow, Text, VFlow } from 'bold-ui'
import { RichTextField } from 'components/form'
import { SessaoQuery, TipoAtendimentoProfissional, VigilanciaEmSaudeBucalEnum } from 'graphql/types.generated'
import React from 'react'
import { isCboMedicoOuCirurgiaoDentista } from 'util/atendimento/cboMedicoOuCirurgiaoDentista'
import { MetaPath } from 'util/metaPath'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { AlergiasReacoesField } from './components/alergias-reacoes/AlergiasReacoesField'
import { AlergiaReacaoModel } from './components/alergias-reacoes/model'
import { NecessidadeProteseField } from './components/NecessidadeProteseField'
import { ProblemaCondicaoModel } from './components/problemas-condicoes/model'
import { ProblemasCondicoesField } from './components/problemas-condicoes/ProblemasCondicoesField'
import { VigilanciaField } from './components/VigilanciaField'

export interface AvaliacaoFormModel {
  texto?: string
  condicoes?: ProblemaCondicaoModel[]
  alergias?: AlergiaReacaoModel[]
  tiposVigilancia?: VigilanciaEmSaudeBucalEnum[]
  necessidadeProtese?: string
  openedAccordions?: string[]
}

export interface AvaliacaoFormProps {
  name: MetaPath<AvaliacaoFormModel>
  cidadao: CidadaoAtendimento
  acessoProfissional: SessaoQuery['sessao']['acesso']
  tipoAtendProf: TipoAtendimentoProfissional
  prontuarioId: ID
  dataAtendimento: Instant
}

export function AvaliacaoForm(props: AvaliacaoFormProps) {
  const { name, cidadao, tipoAtendProf, prontuarioId, dataAtendimento } = props

  const isAtendimentoOdonto = tipoAtendProf === TipoAtendimentoProfissional.ATENDIMENTO_ODONTOLOGICO
  const somenteCiap = !isCboMedicoOuCirurgiaoDentista(
    props.acessoProfissional.__typename === 'Lotacao' && props.acessoProfissional.cbo.cbo2002
  )

  return (
    <VFlow>
      <RichTextField
        name={name.texto}
        maxLength={4000}
        placeholder='Insira impressões adicionais sobre a avaliação dos problemas/condições detectados.'
      />

      <HeadingSection
        level={3}
        title={
          <HFlow hSpacing={0.25} alignItems='center'>
            Problemas e/ou condições avaliados neste atendimento
            <Text color='danger'>*</Text>
          </HFlow>
        }
      >
        <Grid>
          <Cell size={12}>
            <ProblemasCondicoesField
              name={name.condicoes}
              somenteCiap={somenteCiap}
              cidadao={cidadao}
              prontuarioId={prontuarioId}
              dataAtendimento={dataAtendimento}
            />
          </Cell>

          <Cell size={12}>
            <AlergiasReacoesField
              name={name}
              prontuarioId={prontuarioId}
              cidadao={cidadao}
              dataAtendimento={dataAtendimento}
            />
          </Cell>

          {isAtendimentoOdonto && (
            <>
              <Cell size={12}>
                <VigilanciaField name={name.tiposVigilancia} />
              </Cell>

              <Cell size={12}>
                <NecessidadeProteseField name={name.necessidadeProtese} />
              </Cell>
            </>
          )}
        </Grid>
      </HeadingSection>
    </VFlow>
  )
}
